const ArrowRight = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#1D1D1B"
      fillRule="evenodd"
      d="M7.1 4.22 14.88 12 7.1 19.78l1.06 1.06L17 12 8.16 3.16 7.1 4.22Z"
      clipRule="evenodd"
    />
  </svg>
);
export default ArrowRight;
